export default __webpack_public_path__ + "static/media/larts.0d6efeb5.png";